import { AppDispatch, RootState } from "../store";
import { generatePDF, User, Status } from "../services/previewPDF";
import { Answer, templatesApi } from "../api";
import { getChapter } from "../services/previewPDF";
import { fetchCover } from "../store/coverSlice";
import { fetchPhotos } from "../store/photosSlice";

const selectAnswers = (s: RootState) => Object.values(s.answers.answers);
const selectCover = (s: RootState) => s.cover.value;
const selectPhotos = (s: RootState) => Object.values(s.photos.photos);
const selectTemplates = (s: RootState) => s.templates.templates;

/* THUNK */
export const generatePdfForCurrentUser =
  () => async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    const templates = selectTemplates(state);
    if (!templates.length) {
      console.error("Templates not loaded");
      return;
    }
    const tpl = templates[0];

    /* ответы → словарь questionId → Answer */
    const answersById: Record<number, Answer> = {};
    selectAnswers(state).forEach((a) => {
      answersById[a.questionId] = a;
    });

    /* TODO: questions нужно загрузить отдельно через templatesApi.getQuestions(tpl.id) */
    /* Пока заглушка — массив пар будет заполняться при наличии ответов */
    const questionAnswerPairs = Object.values(answersById).map((ans, idx) => ({
      isRemoved: !ans.text,
      chapter: getChapter(idx, String(tpl.id)),
      question: ans.questionText,
      answer: ans.text,
      clientQuestion: ans.clientQuestion ?? "",
      number: String(idx + 1),
      isQuestionHidden: ans.clientQuestion === "-",
    }));

    /* обложка */
    let cover = selectCover(state);
    if (!cover || cover.templateId !== tpl.id) {
      const r = await dispatch(fetchCover(tpl.id));
      if (fetchCover.fulfilled.match(r)) cover = r.payload;
      else return console.error("Cover fetch failed");
    }

    /* фото */
    let rawPhotos = selectPhotos(state);
    if (!rawPhotos.length) {
      const r = await dispatch(fetchPhotos(tpl.id));
      if (fetchPhotos.fulfilled.match(r)) {
        rawPhotos = r.payload;
      } else {
        rawPhotos = [];
      }
    }

    const photos = rawPhotos.map((p) => ({
      imgData: undefined as any,
      photoUrl: p.url,
      date: p.createdAt,
      description: p.description,
      questionToPrecede: p.questionTxt || "",
      hideDate: !p.showDate,
      hideDescription: !p.showDescription,
      questionTxt: p.questionTxt || "",
      status: p.position as Status,
    }));

    /* User */
    const user: User = {
      questionAnswerPairs,
      questionTemplates: [{ id: String(tpl.id), name: tpl.name }],
      bookName: cover ? cover.bookTitle : "Название книги",
      authorName: cover ? cover.authorName : "Инициалы автора",
      partnerName: cover ? cover.receiverName : "",
      coverUrl: cover ? cover.coverUrl : "",
      photos,
      blanks: [],
    };

    try {
      const { doc, pagesMap } = await generatePDF(user);
      const blob = doc.output("blob");
      return { blob, pagesMap };
    } catch (err) {
      console.error("PDF generation failed:", err);
    }
  };
